/**
 * Available Order Service Types
 */
export enum OrderServiceTypeNameEnum {
  EAT_IN = 'Eat In',
  TAKE_OUT = 'Take Out'
}

/**
 * Available Order Service Types to create order in DB
 */
 export enum OrderServiceTypeIndexEnum {
  EAT_IN = 1,
  TAKE_OUT = 2
}
